export default __webpack_public_path__ + "static/media/bg2.3cb8c578.png";